import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError } from './GrapeAPIError'

type UpdateStripePriceIdsParams = {
  employer_id: string
  stripe_price_ids: string[]
}

export function useUpdateStripePriceIds () {
  return useMutation({
    mutationFn: async (params: UpdateStripePriceIdsParams) => {
      const response = await fetchWithHeaders(`/api/web/admin/stripe/prices/${params.employer_id}`, {
        method: 'PUT',
        body: JSON.stringify(params),
      })

      if (!response.ok) {
        const error = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: error.message,
          errors: error.errors,
        })
      }

      return response.json()
    }
  })
}
